export const DefaultHiddenIconsStatuses = [
    "dropout", "submitted"
]